import { useState } from 'react';
import { Header } from './Header';
import { InstallPrompt } from './InstallPrompt';
import { StatusView } from './StatusView';
import { ProjectsView } from './ProjectsView';
import { FoutenView } from './FoutenView';

export function Dashboard({ token, onLogout }) {
  const [activeView, setActiveView] = useState('status');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100%' }}>
      <Header
        onLogout={onLogout}
        activeView={activeView}
        onViewChange={setActiveView}
        token={token}
      />

      <InstallPrompt />

      <div style={{ flex: 1, overflow: 'auto', background: '#f9fafb' }}>
        {activeView === 'status' && <StatusView token={token} />}
        {activeView === 'projects' && <ProjectsView token={token} />}
        {activeView === 'fouten' && <FoutenView token={token} />}
      </div>
    </div>
  );
}
